import { ReactComponent as Filterclearbutton } from '../../Assets/img/Filter-input-clearbutton.svg';
import { ReactComponent as Filterclearbuttonhover } from '../../Assets/img/Filter-input-clearbutton-hover.svg';

function TextFilterBox(props) {
    return (
        <label className="filter-label" >
            <input type="text" className="filter-input" value={props.searchPlaceHolder} onChange={props.searchHandler} placeholder="-All-" />
            {props.searchPlaceHolder != "" &&
                <div className="filter-clear-icon-container" >
                    <Filterclearbuttonhover className="filter-clear-icon hover-icon" onClick={props.clearFilterHandler} />
                    <Filterclearbutton className="filter-clear-icon" />
                </div>
            }
        </label>
    )
}

export default TextFilterBox;